import React from "react";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import { stripePromise } from "../../constants/common";
import "./StripeCheckout.css";

interface StripeCheckoutProps {
  clientSecret: string;
  onSuccess: () => void;
  onCancel: () => void;
}

const StripeCheckout: React.FC<StripeCheckoutProps> = ({
  clientSecret,
  onSuccess,
  onCancel,
}) => {
  if (!clientSecret) {
    return <div className="checkout-loading">Loading...</div>;
  }

  return (
    <div className="embedded-checkout-container">
      <EmbeddedCheckoutProvider
        stripe={stripePromise}
        options={{
          clientSecret,
          onComplete: onSuccess,
        }}
      >
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
};

export default StripeCheckout;
